import React, { useCallback, useRef } from "react"
import { FiUser, FiMail, FiLock, FiArrowLeft } from "react-icons/fi"
import { FormHandles } from "@unform/core"
import { Form } from "@unform/web"
import * as Yup from "yup"
import { Link, useHistory } from "react-router-dom"

import api from "../../services/api"

//import defaultAvatar from "../../assets/Avatar padrão.jpg"

import { useToast } from "../../hooks/toast"

import getValidationErrors from "../../utils/getValidationErrors"

import Input from "../../components/InputUnform"
import Button from "../../components/Button"

import { Container, Content } from "./styles"
import { useAuth } from "../../hooks/auth"

interface ProfileFormData {
  name: string
  email: string
  old_password: string
  password: string
  password_confirmation: string
}

const Profile: React.FC = () => {
  const formRef = useRef<FormHandles>(null)
  const { addToast } = useToast()
  const history = useHistory()

  const { user, updateUser } = useAuth()

  const handleSubmit = useCallback(
    async (data: ProfileFormData) => {
      try {
        formRef.current?.setErrors({})

        const schema = Yup.object().shape({
          name: Yup.string().required("Nome obrigatório"),
          email: Yup.string()
            .required("E-mail obrigatório")
            .email("Digite um e-mail válido"),
          old_password: Yup.string(),
          password: Yup.string().when("old_password", {
            is: (val) => !!val.length,
            then: Yup.string().required("Campo obrigatório"),
            otherwise: Yup.string(),
          }),
          password_confirmation: Yup.string()
            .when("old_password", {
              is: (val) => !!val.length,
              then: Yup.string().required("Campo obrigatório"),
              otherwise: Yup.string(),
            })
            .oneOf([Yup.ref("password"), null], "Confirmação incorreta"),
        })

        await schema.validate(data, {
          abortEarly: false,
        })

        const { name, email, old_password, password, password_confirmation } =
          data

        const formData = {
          name,
          email,
          old_password,
          password,
          password_confirmation,
        }

        const response = await api.put("/profile", formData)
        updateUser(response.data.user)

        history.push("/dashboard")

        addToast({
          type: "success",
          title: "Perfil atualizado",
          description:
            "Suas informações do perfil foram atualizadas com sucesso",
        })
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err)

          formRef.current?.setErrors(errors)

          return
        }

        addToast({
          type: "error",
          title: "Erro na atualização",
          description: "Ocorreu um erro ao atualizar perfil, tente novamente",
        })
      }
    },
    [addToast, history, updateUser]
  )

  // const handleAvatarChange = useCallback(
  //   (e: ChangeEvent<HTMLInputElement>) => {
  //     if (e.target.files) {
  //       const data = new FormData()

  //       data.append("avatar", e.target.files[0])

  //       api.patch("/users/avatar", data).then((response) => {
  //         updateUser(response.data)

  //         addToast({
  //           type: "success",
  //           title: "Avatar atualizado",
  //         })
  //       })
  //     }
  //   },
  //   [addToast, updateUser]
  // )

  return (
    <Container>
      <header>
        <div>
          <Link to="/dashboard">
            <FiArrowLeft />
          </Link>
        </div>
      </header>

      <Content>
        <Form
          ref={formRef}
          initialData={{ name: user.name, email: user.email }}
          onSubmit={handleSubmit}
        >
          {/* <AvatarInput>
            <img
              src={user.avatar_url ? user.avatar_url : defaultAvatar}
              alt={user.name}
            />
            <label htmlFor="avatar">
              <FiCamera />
              <input type="file" id="avatar" onChange={handleAvatarChange} />
            </label>
          </AvatarInput> */}

          <div style={{ marginTop: "150px" }}>
            <h1>Meu Perfil</h1>

            <Input
              name="name"
              icon={FiUser}
              type="text"
              placeholder="Nome"
              containerStyle={{ marginBottom: 10 }}
            />
            <Input
              name="email"
              icon={FiMail}
              type="text"
              placeholder="E-mail"
            />

            <Input
              containerStyle={{ marginTop: 24, marginBottom: 10 }}
              name="old_password"
              icon={FiLock}
              type="password"
              placeholder="Senha atual"
            />

            <Input
              name="password"
              icon={FiLock}
              type="password"
              placeholder="Nova senha"
              containerStyle={{ marginBottom: 10 }}
            />

            <Input
              name="password_confirmation"
              icon={FiLock}
              type="password"
              placeholder="Confirmar senha"
            />

            <Button type="submit">Confirmar mudanças</Button>
          </div>
        </Form>
      </Content>
    </Container>
  )
}

export default Profile
